import { BaseClient, IActionResponse, IActionResult } from "../";
import { Module, SettingModuleRouteMap } from "../../../assets/types/common";
import { ApiParams, IPagedResult, SearchDto } from "../../../assets/utils/lib";

export class SettingClient<T> extends BaseClient {
  routes: string[] = [];
  constructor(moduleType: Module) {
    super();
    this.routes = [SettingModuleRouteMap[moduleType], "configuration"];
  }

  async getSettingAsync(id?: string | undefined): Promise<T> {
    const actions: string[] = ["GetSetting"];
    const params: ApiParams[] = [new ApiParams("settingId", id, true)];
    const result: T = await this.getAsync<T>(actions, params);
    return result;
  }

  async getSettingsAsync(): Promise<T[]> {
    const actions: string[] = ["GetAllSettings"];
    const params: ApiParams[] = [];
    const result: T[] = await this.getAsync<T[]>(actions, params);
    return result;
  }

  async searchSettingsAsync(
    payload: SearchDto | undefined
  ): Promise<IPagedResult<T>> {
    const actions: string[] = ["SearchSettings"];
    const result: IPagedResult<T> = await this.postAsync<
      SearchDto,
      T,
      IPagedResult<T>
    >(actions, payload);
    return result;
  }

  async saveSettingAsync(payload?: T | undefined): Promise<IActionResult<T>> {
    const actions: string[] = ["SaveSetting"];
    return await this.postAsync<T>(actions, payload);
  }

  async deleteSettingAsync(id?: string | undefined): Promise<IActionResponse> {
    const actions: string[] = ["DeleteSetting"];
    const params: ApiParams[] = [new ApiParams("settingId", id, true)];
    return await this.deleteAsync(actions, params);
  }
}
